module.exports = __webpack_public_path__ + "h5/img/vip3.f6337404.png";